import React from "react";
import type { StatBadge } from "../../../models/reader";

interface StatBadgesProps {
  stats: StatBadge[];
}

export const StatBadges: React.FC<StatBadgesProps> = ({ stats }) => {
  return (
    <div style={styles.row}>
      {stats.map((stat) => (
        <div key={stat.label} style={styles.badge}>
          <span style={styles.label}>{stat.label}</span>
          <span
            style={
              stat.isItalic
                ? { ...styles.value, ...styles.italic }
                : styles.value
            }
          >
            {stat.value}
          </span>
        </div>
      ))}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  row: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
  },
  badge: {
    background: "rgba(255,255,255,0.05)",
    border: "0.5px solid rgba(255,255,255,0.1)",
    borderRadius: 6,
    padding: "5px 10px",
    display: "flex",
    flexDirection: "column",
    gap: 1,
    minWidth: 64,
  },
  label: {
    fontSize: 10,
    // color: "#6b6a64",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  value: {
    fontSize: 13,
    fontWeight: 500,
    // color: "#d4d0c8",
  },
  italic: {
    color: "#f59e0b",
    fontStyle: "italic",
  },
};

export default StatBadges;
